<section id="why-us" class="why-us">
  <div class="container">

    <div class="row">
      <div class="col-xl-4 col-lg-5" data-aos="fade-up">
        <div class="content" style="background: #ff8200 !important;">
          <h1 style="font-weight: bold">Student Art Contest</h1>
          <p>
            DART offers an annual Student Art Contest that is open to students in grades K-12 throughout North Texas. It has grown to be one of the agency’s most popular outreach events.
          </p>
          <div class="text-center">
            <a target="_blank" href="https://www.dart.org/guide/supporting-services/transit-education/dart-student-art-contest" class="more-btn">Learn More <i class="bx bx-chevron-right"></i></a>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-5" data-aos="fade-up">
        <div class="content">
          <h1 class="bold">Discover Transit Education</h1>
          <p>
            DART provides its Transit Education Program to area schools, scout groups, recreation centers, and other organizations.
          </p>
          <div class="text-center">
            <a target="_blank" href="https://www.dart.org/transiteducation" class="more-btn">Schedule a Presentation <i class="bx bx-chevron-right"></i></a>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-lg-5" data-aos="fade-up">
        <div class="content">
          <h1 class="bold">Gallery</h1>
          <p>
            See how students brought this year’s theme to life through their winning entries!
          </p>
          <div class="text-center">
            <a target="_blank" href="/gallery/{{ lastCompletedContestYear }}" class="more-btn">View the Winning Art <i class="bx bx-chevron-right"></i></a>
            <!--<a pageScroll href="#values" class="more-btn">View the Winning Art <i class="bx bx-chevron-right"></i></a>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
